module.exports = __webpack_public_path__ + "img/share-coupon3.20a1afd8.png";